export enum ETab {
    MY_SEGMENTS,
    SHARED_SEGMENTS,
}
